// *******************************************************************************
// 1.0 - Mobile menu toggle
// *******************************************************************************

attachEvent('.mobile-hamburger', 'click', (ev) => {
  ev.preventDefault();

  // Open menu
  document.body.classList.toggle('is-open-menu');
  const hamburger = ev.target.closest('.mobile-hamburger');

  const isOpen = hamburger.classList.contains('is-open');

  hamburger.classList.toggle('is-open', !isOpen);
  hamburger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
});

// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header-main');

  if (header) {
    const bodyPaddingTop = () => {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    };

    bodyPaddingTop();

    const headerObserver = new ResizeObserver(bodyPaddingTop);
    headerObserver.observe(header);
  }
});

// *******************************************************************************

attachEvent('.has-submenu .header-main__link', 'click', (ev) => {
  const parent = ev.target.closest('.has-submenu');
  const isActive = parent.classList.contains('is-active');

  document.querySelectorAll('.has-submenu').forEach((el) => {
    el.classList.remove('is-active');
    el.querySelector('.header-main__link').setAttribute('aria-expanded', 'false');
  });
  document.body.classList.remove('is-open-submenu');

  if (!isActive) {
    parent.classList.add('is-active');
    ev.target.closest('.header-main__link').setAttribute('aria-expanded', 'true');
    document.body.classList.add('is-open-submenu');
  }
});

attachEvent('.header-main__overlay, .header-main__submenu-close', 'click', () => {
  document.querySelectorAll('.has-submenu').forEach((el) => el.classList.remove('is-active'));
  document.body.classList.remove('is-open-submenu');
});
